import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { _AbcGridComponent } from '@barthauer/abc/ui-components';
import { Column } from 'devextreme/ui/data_grid';
import { BehaviorSubject, combineLatest, map, Observable, shareReplay, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  @Output() changed = new EventEmitter();
  public isMenuOpened$ = new BehaviorSubject<boolean>(true);
  // Observable that emits both the screen size and the sidebar open/closed state
  public screen$: Observable<{ screenSize: string; isMenuOpened: boolean; }> =
    combineLatest([
      this.breakpointObserver.observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge
      ]).pipe(
        map((state: BreakpointState) => {
          if (state.breakpoints[Breakpoints.XSmall]) return 'XSmall';
          if (state.breakpoints[Breakpoints.Small]) return 'Small';
          if (state.breakpoints[Breakpoints.Medium]) return 'Medium';
          if (state.breakpoints[Breakpoints.Large]) return 'Large';
          if (state.breakpoints[Breakpoints.XLarge]) return 'XLarge';
          return 'Undefined';
        })
      ),
      this.isMenuOpened$
    ]).pipe(
      map(([screenSize, isMenuOpened]) => ({
        screenSize,
        isMenuOpened
      })),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large])
      .subscribe(() => this.changed.next(null));
  }

  private isLargeScreen() {
    const isLarge = this.breakpointObserver.isMatched(Breakpoints.Large);
    const isXLarge = this.breakpointObserver.isMatched(Breakpoints.XLarge);

    return isLarge || isXLarge;
  }

  public get sizes() {
    return {
      'screen-x-small': this.breakpointObserver.isMatched(Breakpoints.XSmall),
      'screen-small': this.breakpointObserver.isMatched(Breakpoints.Small),
      'screen-medium': this.breakpointObserver.isMatched(Breakpoints.Medium),
      'screen-large': this.isLargeScreen(),
    };
  }
  //Set grid column widths manually (Based on screenSize & state of sideBar) using a parameterized function.
  public setGridColumnsWidth(columnsHeader: Column[], grid: _AbcGridComponent, screenSize: string, isMenuOpened: boolean, getColumnWidth: (key: string, isMenuOpened: boolean, largeScreenAddition?: number) => string): void {
    columnsHeader.forEach(col => {
      col.width = getColumnWidth(col.dataField, isMenuOpened, screenSize === "XLarge" ? 50 : 0);
    });
    grid?.instance.option('columns', columnsHeader);
  }
}
